function SendgridResults(oneemail, bounceactivity, blockactivity) {
    return (
      `<div style="font-family: Arial, sans-serif; padding: 20px; max-width: 800px;">
        <div style="padding: 15px; background-color: #f5f9fa; border: 1px solid #e0e6e8; border-radius: 8px; margin-bottom: 20px;">
          <div style="margin-bottom: 5px;"><strong>To:</strong> ${oneemail.to_email}</div>
          <div style="margin-bottom: 5px;"><strong>From:</strong> ${oneemail.from_email}</div>
          <div style="margin-bottom: 5px;"><strong>Updated:</strong> ${oneemail.last_event_time}</div>
          <div style="margin-bottom: 5px;"><strong>Subject:</strong> ${oneemail.subject}</div>
          <div style="margin-bottom: 5px;"><strong>Message ID:</strong> ${oneemail.msg_id}</div>
          <div style="margin-bottom: 5px;"><strong>Received by:</strong> Not yet Implemented</div>
          <div><strong>Delivery Status:</strong> ${oneemail.status}</div>
        </div>
    
        <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
          <tr>
            <th colspan="2" style="background-color: #188182; color: white; padding: 10px; text-align: left; border-top-left-radius: 8px; border-top-right-radius: 8px;">
              Bounce Activity
            </th>
          </tr>
          <tr>
            <th style="background-color: #f0f0f0; padding: 8px; border: 1px solid #ddd; width: 120px;">Status</th>
            <th style="background-color: #f0f0f0; padding: 8px; border: 1px solid #ddd;">Reason</th>
          </tr>
          ${bounceactivity.map((row) => {
              return `<tr>
                <td style="padding: 8px; border: 1px solid #ddd;">${row.status}</td>
                <td style="padding: 8px; border: 1px solid #ddd;">${row.reason}</td>
              </tr>`
          }).join('')}
        </table>
       
        <table style="width: 100%; border-collapse: collapse;">
          <tr>
            <th colspan="2" style="background-color: #188182; color: white; padding: 10px; text-align: left; border-top-left-radius: 8px; border-top-right-radius: 8px;">
              Block Activity
            </th>
          </tr>
          <tr>
            <th style="background-color: #f0f0f0; padding: 8px; border: 1px solid #ddd; width: 120px;">Status</th>
            <th style="background-color: #f0f0f0; padding: 8px; border: 1px solid #ddd;">Reason</th>
          </tr>
          ${blockactivity
              .map(row => `<tr>
                <td style="padding: 8px; border: 1px solid #ddd;">${row.status}</td>
                <td style="padding: 8px; border: 1px solid #ddd;">${row.reason}</td>
              </tr>`)
              .filter(row => row.trim() !== '') // Filter out empty rows
              .join('')}
        </table>
      </div>`
    );
}

export default SendgridResults;
